import React, { useState } from 'react';
import '../styles/ImageDisplay.css';

const ImageDisplay = ({ src, alt, className = '', onClick, style = {} }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const handleLoad = () => {
    setLoading(false);
    setError(false);
  };

  const handleError = () => {
    setLoading(false);
    setError(true);
  };

  const handleClick = () => {
    if (onClick && !loading && !error) {
      onClick();
    }
  };

  return (
    <div 
      className={`image-display ${className} ${loading ? 'loading' : ''} ${error ? 'error' : ''} ${onClick ? 'clickable' : ''}`}
      style={style}
      onClick={handleClick}
    >
      {loading && (
        <div className="image-loading">
          <div className="loading-spinner"></div>
          <span>Loading...</span>
        </div>
      )}
      
      {error && (
        <div className="image-error">
          <div className="error-icon">❌</div>
          <span>Failed to load image</span>
        </div>
      )}
      
      <img
        src={src}
        alt={alt}
        onLoad={handleLoad}
        onError={handleError}
        style={{ 
          display: loading || error ? 'none' : 'block',
          width: '100%',
          height: '100%',
          objectFit: 'contain'
        }}
      />
    </div>
  );
};

export default ImageDisplay;
